export default __webpack_public_path__ + "static/media/ohms-law.da01d5a2.jpg";